import React, { useContext, useEffect, useState } from 'react'
import useDebounce from '../../../../../components/Hooks/useDebounce'
import WorkFlowConfigurationContext from '../../../workflow/configuration/WorkFlowConfigurationProvider'
import ManageTaskContainer from '../../../workflow/configuration/facility/wizard/Commons/ManageTaskContainer'

export default function LogPatientHistoryEventTaskLineItem({ onChanged, task, facility, user, onDelete, onSetProperty, config, errors, values, setValue }) {
    const PROP_NAME = "LOG_PATIENT_HISTORY"
    const { loadTaskProperties } = useContext(WorkFlowConfigurationContext)
    const [data, setData] = useState()

    useEffect(() => {
        const load = async () =>
            setData(await loadTaskProperties(task, PROP_NAME))
        load()
        return () => {
            // alert('Close')
            setData()
        }
    }, [task])

    return (data ? <LogPatientHistoryEventTaskLineItemInput
        task={task}
        onDelete={onDelete}
        defaultValue={data} /> : <div>Loading</div>)
}


function LogPatientHistoryEventTaskLineItemInput({ onChanged, task, facility, user, onDelete, onSetProperty, config, errors, values, setValue, defaultValue }) {
    const PROP_NAME = "LOG_PATIENT_HISTORY"
    const { setTaskProperty, loadTaskProperties } = useContext(WorkFlowConfigurationContext)
    const _handleCreateName = (P) => {
        var name = 'Log to patients history'
        if (P.event)
            name = 'Log ' + P.event + ' to patients history'
        setTaskName(name)
        return name
    }
    const [props, setProps] = useState(defaultValue)
    const [taskName, setTaskName] = useState(task.taskName)

    const debouncedInputValue = useDebounce(props, 300);


    const _handleSetProperty = (k, value) => //{ console.log('Set Props'); setProps({ ...props, [k]: value }) }
        setProps({ ...props, [k]: value })
    // setTaskProperty(props, _handleCreateName({ ...props, [k]: value }), task, PROP_NAME, { ...props, [k]: value })
    //     .then((r) => setProps({ ...props, [k]: value }))

    // const _handleSetProperty = (k, value) => //{ console.log('Set Props'); setProps({ ...props, [k]: value }) }
    //     setTaskProperty(props, _handleCreateName({ ...props, [k]: value }), task, PROP_NAME, { ...props, [k]: value })
    //         .then((r) => setProps({ ...props, [k]: value }))

    useEffect(() => {
        // const _handleSetProperty = (k, value) => //{ console.log('Set Props'); setProps({ ...props, [k]: value }) }
        setTaskProperty(props, _handleCreateName(debouncedInputValue), task, PROP_NAME, debouncedInputValue)
            .then((r) => setProps(debouncedInputValue))
    }, [debouncedInputValue]);
    useEffect(() => {
    }, []);
    // const _handleLoadProps = async () =>
    //     setProps(await loadTaskProperties(task, PROP_NAME))


    return (<ManageTaskContainer Task={{ ...task, taskName: taskName }} onDelete={onDelete}>
        <b>Event Category </b>
        <div>
            <input
                key={`Event Description`}
                defaultValue={props.category}
                onChange={(e) => _handleSetProperty('category', e.target.value)} className='form-control form-control-sm' placeholder='Event Category' />
        </div>
        <b>Event Description </b>
        <div>
            <input
                key={`Event Description`}
                defaultValue={props.event}
                onChange={(e) => _handleSetProperty('event', e.target.value)} className='form-control form-control-sm' placeholder='Event Description' />
        </div>
    </ManageTaskContainer>
    )
}